import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  Alert,
  Paper,
  Link,
  Divider,
  IconButton,
} from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import CryptoJS from "crypto-js";
import OTPVerificationModal from "./OTPVerificationModal";
import {
  AccountBalanceWallet,
  Send,
  CurrencyRupee,
  Receipt,
  List,
  Payment,
  Lock,
  Fingerprint,
  Add,
} from "@mui/icons-material";
import BiometricModal from "./BiometricModal";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import EKYCModal from "./EKYCModal";
import TwoFAModal from "./TwoFAModal";
import { toast } from "react-toastify";
import { Walllet_Icon, AadhaarPayIcon } from "../../../res/icons";
import WalletIcon from '@mui/icons-material/Wallet';
import UploadIcon from '@mui/icons-material/Upload';

const LandingPage = () => {
  const navigate = useNavigate();
  const [walletBalance, setWalletBalance] = useState(0);
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [biometricModalOpen, setBiometricModalOpen] = useState(false);
  const [merchantStatus, setMerchantStatus] = useState(null);
  const [showAnimation, setShowAnimation] = useState(false);
  const [showMobileOtp, setShowMobileOtp] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showRejected, setShowRejected] = useState(false);
  const [ekycStatus, setEkycStatus] = useState();
  const [rejectReason, setRejectReason] = useState(
    "Your application was rejected due to incomplete documentation."
  );
  const [biometricData, setBiometricData] = useState({});
  const [openEKYC, setOpenEKYC] = useState(false);
  const [opentwofa, setTwoFa] = useState(false);
  const [latitude, setLatitude] = useState("");
  const [banks, setBanks] = useState([]);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [docsUploaded, setDocsUploaded] = useState(false);
  const [longitude, setLongitude] = useState("");

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const token = sessionStorage.getItem("jwtToken");
        if (!token) {
          toast.error("Authentication token missing.");
          return;
        }

        const response = await fetch(
          "https://api.ipaisa.co.in/myapp/auth/cms/getAllBanks",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        setBanks(data.body.data || []);
      } catch (error) {
        console.error("Error fetching banks:", error);
        toast.error("Failed to load bank list.");
      }
    };

    fetchBanks();
  }, []);

  const fetchWalletBalance = async () => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.get(
        "https://api.ipaisa.co.in/myapp/auth/getwalletbalance",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setWalletBalance(response.data.walletBalance);
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        console.error("Error getting location:", error);
        toast.error("Failed to get location.");
      }
    );
  }, []);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Failed to get location. Please check your location settings.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleCollectCashClick = async () => {
    setShowAnimation(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.post(
        "https://api.ipaisa.co.in/myapp/auth/cms/cmsLoginPayload",
        {
          latitude: latitude,
          longitude: longitude,
          amount: "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;
      console.log("API Response:", data);

      if (data.statusCode === "OK") {
        const payload = data.body.payload;
        const requestData = {
          additionalParams: payload.additionalParams,
          latitude: payload.latitude,
          loginType: payload.loginType,
          longitude: payload.longitude,
          supermerchantId: payload.supermerchantId,
          merchantId: payload.merchantId,
          merchantPin: payload.merchantPin,
          mobileNumber: payload.mobileNumber,
          amount: payload.amount,
          superMerchantSkey: payload.superMerchantSkey,
        };

        const parsedBase64Key = CryptoJS.enc.Base64.parse(
          requestData.superMerchantSkey
        );
        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(requestData),
          parsedBase64Key,
          { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        ).toString();

        const encryptInfo = btoa(encryptedData);
        const redirectUrl = `https://fpcorp.tapits.in/UberCMSBC/#/login?data=${encodeURIComponent(encryptInfo)}&skey=${requestData.superMerchantSkey}`;
        window.location.href=redirectUrl;
      } else {
        alert("API Error: " + data.message);
      }
    } catch (error) {
      console.error("Error calling API:", error);
      alert("An error occurred while processing your request.");
    } finally {
      setShowAnimation(false);
    }
  };

  const handleAadhaarPayClick = () => navigate("/AadhaarPay");
  const handleCashWithdrawalClick = () => navigate("/cashwithdrawal");
  const handleCashDepositClick = () => navigate("/cashdeposit");

  useEffect(() => {
    fetchWalletBalance();
  }, []);

  const services = [
   
    {
      name: "Aadhaar Pay",
      icon: <AadhaarPayIcon fontSize="large" />,
      gradient: "white",
      onClick: handleAadhaarPayClick,
      isBalanceCard: false
    },
    {
      name: "Cash Withdrawal",
      icon: <AccountBalanceWallet fontSize="large" />,
      gradient: "linear-gradient(45deg, #ff9800, #ff5722)",
      onClick: handleCashWithdrawalClick,
      isBalanceCard: false
    },
    {
      name: "Cash Deposit",
      icon: <CurrencyRupee fontSize="large" />,
      gradient: "linear-gradient(45deg, #4caf50, #388e3c)",
      onClick: handleCashDepositClick,
      isBalanceCard: false
    },
    {
      name: "Collect Cash",
      icon: <Payment fontSize="large" />,
      gradient: "linear-gradient(45deg, #e91e63, #880e4f)",
      onClick: handleCollectCashClick,
      isBalanceCard: false
    },
  
  ];

  useEffect(() => {
    const fetchMerchantStatus = async () => {
      const token = sessionStorage.getItem("jwtToken");
      if (!token) {
        console.error("JWT token not found in sessionStorage");
        return;
      }

      try {
        const response = await axios.get(
          "https://api.ipaisa.co.in/myapp/auth/cms/verifyMerchantStatus",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.data) {
          setMerchantStatus(response.data);
          setShowMobileOtp(response.data.body?.mobileVerifyStatus !== "TRUE");
          setShowWarning(response.data.body?.onBoardingStatus !== "TRUE");
          setRejectReason(response.data.body.rejectReason);
          setEkycStatus(response.data.body.ekycStatus);
          setDocsUploaded(response.data.body?.docUploaded !== "FALSE");
          setShowRejected(
            response.data.body?.onBoardingStatus !== "TRUE" &&
            response.data.body?.applicationStatus === "REJECT"
          );
          setBiometricData({
            ekycStatus: response.data.body?.ekycStatus,
            twoFAStatus: response.data.body?.twoFAStatus,
          });
        }
      } catch (error) {
        console.error("Error fetching merchant status:", error);
      }
    };

    fetchMerchantStatus();
  }, []);

  const handleAddMoney=()=>{

    navigate("/addmoney")
  };

  const handleReApplyClick = async () => {
    const token = sessionStorage.getItem("jwtToken");
    try {
      await axios.delete(
        "https://api.ipaisa.co.in/myapp/auth/cms/removeRejectedApplication",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      sessionStorage.setItem("cmsMerchantApplyStatus", "False");
      navigate("/dashboard");
    } catch (error) {
      console.error("Error removing rejected application:", error);
    }
  };

  const rows = 18;
  const cols = 18;
  const totalSquares = rows * cols;

  return (
    <>
      {showRejected ? (
        <Box
          sx={{
            minHeight: "100vh",
            background: "linear-gradient(to right, #e3f2fd, #bbdefb)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            py: 5,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Paper
            sx={{
              width: "400px",
              height: "auto",
              mb: 2,
              p: 2,
              backgroundColor: "#ffebee",
              borderLeft: "6px solid #d32f2f",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#d32f2f",
                mb: 1,
              }}
            >
              Rejected!
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#555",
                mb: 1,
              }}
            >
              Your application has been rejected.
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#555",
                mb: 2,
              }}
            >
              Reason: {rejectReason}
            </Typography>
            <Link
              component="button"
              variant="body2"
              sx={{
                color: "#1976d2",
                fontWeight: "medium",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={handleReApplyClick}
            >
              Click here to re-apply application form
            </Link>
          </Paper>
        </Box>
      ) : showWarning ? (
        <Box
          sx={{
            minHeight: "100vh",
            background: "linear-gradient(to right, #e3f2fd, #bbdefb)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            py: 5,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
              width: "80%",
              maxWidth: "900px",
            }}
          >
            <Paper
              sx={{
                width: "400px",
                height: "150px",
                p: 3,
                backgroundColor: "#fff3e0",
                borderLeft: "6px solid #ffa000",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: "#ffa000",
                  mb: 1.5,
                }}
              >
                Pending!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#555",
                  mb: 1.5,
                }}
              >
                We are currently processing your application.
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#1976d2",
                  fontWeight: "medium",
                }}
              >
                Please contact support for further assistance.
              </Typography>
            </Paper>

            {!docsUploaded && (
              <>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    height: "180px",
                    borderColor: "rgba(255, 255, 255, 0.5)",
                    borderWidth: "1px",
                    alignSelf: "center",
                  }}
                />
                <Card
                  onClick={() => navigate("/merchantfileup")}
                  sx={{
                    background: "linear-gradient(45deg, #ff8a00, #e52e71)",
                    color: "white",
                    padding: "16px 24px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    width: "300px",
                    height: "150px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1.5,
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                      background: "linear-gradient(45deg, #e52e71, #ff8a00)",
                    },
                  }}
                >
                  <UploadIcon sx={{ fontSize: "2rem", color: "white" }} />
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Upload Documents
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.9 }}>
                    Click to submit required files
                  </Typography>
                </Card>
              </>
            )}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            background: "linear-gradient(to right, #e3f2fd, #bbdefb)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            marginTop: '3%',
            position: "relative",
            overflow: "hidden",
          }}
        >
          <AnimatePresence>
            {showAnimation && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{
                  position: "fixed",
                  marginTop: "13%",
                  marginLeft: "15%",
                  width: `${cols * 40}px`,
                  height: `${rows * 40}px`,
                  display: "grid",
                  gridTemplateColumns: `repeat(${cols}, 20px)`,
                  gridAutoRows: "20px",
                  gap: "10px",
                  zIndex: 1000,
                }}
              >
                {[...Array(totalSquares)].map((_, index) => {
                  const row = Math.floor(index / cols);
                  let opacity = 1;

                  if (row === 0) opacity = 0.3;
                  else if (row === 1) opacity = 0.5;
                  else if (row === 2) opacity = 0.7;
                  else opacity = 1;

                  return (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: opacity, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.5 }}
                      transition={{
                        duration: 0.1,
                        delay: index * 0.003,
                        ease: "easeInOut",
                      }}
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: `rgba(255, 0, 0, ${opacity})`,
                      }}
                    />
                  );
                })}
              </motion.div>
            )}
          </AnimatePresence>

          <Box
            sx={{
              textAlign: "center",
              bgcolor: "rgba(255, 255, 255, 0.85)",
              padding: "2rem",
              borderRadius: 3,
              boxShadow: "none",
              position: "relative",
              zIndex: 1,
              width: "100%",
              maxWidth: "100%",
            }}
          >
            {showMobileOtp && (
              <>
                <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                      fontWeight: "bold",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: 1,
                    }}
                    component={motion.h4}
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                  >
                    Welcome to Our Platform
                  </Typography>
                </Grid>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{ color: "#555" }}
                  component={motion.p}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3, duration: 0.6 }}
                >
                  Click below to verify your OTP and continue.
                </Typography>

                <Button
                  variant="contained"
                  size="large"
                  startIcon={<Lock sx={{ fontSize: "1.25rem" }} />}
                  sx={{
                    borderRadius: "12px",
                    fontWeight: "bold",
                    px: 4,
                    py: 1.75,
                    fontSize: "1rem",
                    textTransform: "none",
                    letterSpacing: "0.5px",
                    background: "linear-gradient(45deg, #1976d2, #2196f3)",
                    boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                    position: "relative",
                    overflow: "hidden",
                    "&:hover": {
                      background: "linear-gradient(45deg, #1565c0, #1976d2)",
                      boxShadow: "0 6px 16px rgba(21, 101, 192, 0.4)",
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "rgba(255, 255, 255, 0.1)",
                      transform: "translateX(-100%)",
                      transition: "transform 0.3s ease",
                    },
                    "&:hover::before": {
                      transform: "translateX(0)",
                    }
                  }}
                  onClick={() => setOtpModalOpen(true)}
                >
                  Verify OTP
                </Button>
              </>
            )}

            {!showMobileOtp &&
              !(
                biometricData.ekycStatus === "TRUE" &&
                biometricData.twoFAStatus === "TRUE"
              ) && (
                <>
                  <Typography
                    variant="body1"
                    paragraph
                    sx={{ color: "#555", mt: 5 }}
                    component={motion.p}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 0.6 }}
                  >
                    Click below to verify your biometric authentication and
                    continue.
                  </Typography>
                </>
              )}

            <BiometricModal
              open={biometricModalOpen}
              banks={banks}
              onClose={() => setTwoFa(false)}
              location={location}
              ekycStatus={biometricData.ekycStatus}
              twoFAStatus={biometricData.twoFAStatus}
              showMobileOtp={showMobileOtp}
            />

<Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: 4
        }}
      >
        <Card
          sx={{
            background: "linear-gradient(45deg, #00c6ff, #0072ff)",
            color: "#fff",
            width: 300,
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0, 118, 255, 0.3)",
            position: "relative",
            overflow: "visible"
          }}
        >
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Wallet Balance
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 'bold', mt: 1 }}>
                  ₹{walletBalance.toFixed(2)}
                </Typography>
              </Box>
              <IconButton
                onClick={handleAddMoney}
                sx={{
                  background: "rgba(255, 255, 255, 0.2)",
                  color: "white",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.3)"
                  }
                }}
              >
                <Add fontSize="large" />
              </IconButton>
            </Box>
          </CardContent>
        </Card>
      </Box>

            <Grid container spacing={3} sx={{ display: 'flex', justifyContent: 'center' }}>
              {services.map((service, index) => (
                <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    <Card
                      sx={{
                        background: service.gradient,
                        color: service.isBalanceCard ? '#fff' : (service.name === "Aadhaar Pay" ? '#D42837' : '#fff'),
                        textAlign: 'center',
                        mt: 5,
                        p: 2,
                        borderRadius: '16px',
                        boxShadow: '0 6px 15px rgba(0,0,0,0.25)',
                        minHeight: '140px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        ...(service.onClick && ekycStatus === "TRUE" ? {
                          '&:hover': {
                            transform: 'scale(1.07)',
                            boxShadow: '0 10px 20px rgba(0,0,0,0.4)',
                          },
                          cursor: 'pointer'
                        } : {})
                      }}
                      onClick={() => {
                        if (ekycStatus === "FALSE" && service.onClick) {
                          toast.error("Your eKyc is pending. Please complete eKYC verification first.", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "colored",
                          });
                        } else if (service.onClick) {
                          service.onClick();
                        }
                      }}
                    >
                      <CardContent>
                        {service.icon}
                        <Typography variant="h6" sx={{ mt: 1, fontWeight: 'bold' }}>
                          {service.name}
                        </Typography>
                        {service.isBalanceCard && (
                          <Typography variant="h5" sx={{ fontWeight: 'bold', mt: 1 }}>
                            ₹{service.balance}
                          </Typography>
                        )}
                        {ekycStatus === "FALSE" && !service.isBalanceCard && (
                          <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
                            Complete eKYC to access
                          </Typography>
                        )}
                      </CardContent>
                    </Card>
                  </motion.div>
                </Grid>
              ))}
            </Grid>

            <OTPVerificationModal
              open={otpModalOpen}
              handleClose={() => setOtpModalOpen(false)}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default LandingPage;